export default function({ app }) {
  app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {
    app.i18n.setLocaleCookie(newLocale)
  }
}
